import React from 'react';
import Modal from '@mui/material/Modal';
import PropagateLoader from 'react-spinners/PropagateLoader';
import './loader.css';

function Loader({ open }) {
  return (
    <Modal
      open={open}
      aria-labelledby="loader-modal"
      aria-describedby="loader-modal-description"
    >
      <div className="loader-container">
        <PropagateLoader color="#4fb1aa" size={25} />
      </div>
    </Modal>
  );
}

export default Loader;
